import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Spinner from '../../../layout/Spinner';
import { apiAction } from '../../../store/generalSlice';
import { parseToInt } from '../../../utils/helpers';

const AttributionSpec = (props) => {
  const dispatch = useDispatch();
  const { action, fieldName, field, state, setState } = props;

  const [addNew, setAddNew] = useState(false);
  const [newObj, setNewObj] = useState({ event_type: 'CLICK_THROUGH', window_days: 1 });

  const eventTypes = ['CLICK_THROUGH', 'VIEW_THROUGH', 'ENGAGED_VIDEO_VIEW'];
  return field && state && setState ? (
    <div key={field.id} className='col-md-6 p-3 border'>
      <label>
        <b>{field.id}: </b>
        {field.description}
      </label>{' '}
      {addNew ? (
        <>
          <div>
            <label>event_type</label>
            <select
              className='form-control'
              value={newObj.event_type}
              onChange={(e) => setNewObj({ ...newObj, event_type: e.target.value })}
            >
              {eventTypes.map((eventType) => (
                <option key={eventType} value={eventType}>
                  {eventType}
                </option>
              ))}
            </select>
          </div>
          <div className='mt-2'>
            <label>window_days</label>
            <input
              type='number'
              className='form-control'
              value={newObj.window_days}
              onChange={(e) => setNewObj({ ...newObj, window_days: e.target.value })}
            />
          </div>

          <div className='mt-2 btn-group'>
            <button
              className='btn btn-outline-success'
              onClick={() => {
                setState((prevState) => {
                  let newState = { ...prevState };
                  if (!newObj.event_type || !newObj.window_days || typeof parseToInt(newObj.window_days) !== 'number') {
                    return prevState;
                  }
                  if (!Array.isArray(prevState[field.id].value)) {
                    newState = {
                      ...prevState,
                      [field.id]: {
                        ...prevState[field.id],
                        value: [newObj],
                      },
                    };
                    return newState;
                  }
                  newState = {
                    ...prevState,
                    [field.id]: {
                      ...prevState[field.id],
                      value: [...prevState[field.id].value, newObj],
                    },
                  };

                  dispatch(
                    apiAction({
                      reduxField: 'action',
                      route: `actions/updateDuplicateAction`,
                      actionId: action._id,
                      fieldName,
                      changes: newState,
                    })
                  );
                  return newState;
                });

                setAddNew(false);
                setNewObj({ event_type: 'CLICK_THROUGH', window_days: 1 });
              }}
            >
              Save
            </button>
            <button
              className='btn btn-outline-secondary'
              onClick={() => {
                setAddNew(false);
                setNewObj({ event_type: 'CLICK_THROUGH', window_days: 1 });
              }}
            >
              Cancel
            </button>
          </div>
        </>
      ) : (
        <div>
          <button className='btn btn-outline-primary' onClick={() => setAddNew(true)}>
            Add New
          </button>
        </div>
      )}
      {Array.isArray(state[field.id]?.value) ? (
        <ul className='mt-2'>
          {state[field.id].value.map((item, index) => (
            <li key={index}>
              {item.event_type} - {item.window_days} days
              <button
                className='btn btn-sm btn-outline-danger ml-2'
                onClick={() => {
                  setState((prevState) => {
                    const newState = { ...prevState };
                    if (Array.isArray(prevState[field.id].value)) {
                      newState[field.id].value = prevState[field.id].value.filter((_, i) => i !== index);
                    }
                    dispatch(
                      apiAction({
                        reduxField: 'action',
                        route: `actions/updateDuplicateAction`,
                        actionId: action._id,
                        fieldName,
                        changes: newState,
                      })
                    );
                    return newState;
                  });
                }}
              >
                X
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      <div className='form-check mt-2'>
        <input
          type='checkbox'
          className='form-check-input'
          checked={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => {
            setState((prevState) => {
              return {
                ...prevState,
                [field.id]: { ...prevState[field.id], isUseSource: e.target.checked },
              };
            });
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state, [field.id]: { ...state[field.id], isUseSource: e.target.checked } },
              })
            );
          }}
        />
        <label className='form-check-label'>Use Source</label>
      </div>
    </div>
  ) : (
    <Spinner />
  );
};

export default AttributionSpec;
